import React from "react";
import Highlighter from "./Highlighter";
import classes from "./styles.module.scss";

// eslint-disable-next-line react/prop-types
const formatOptionLabel = ({ label }, { inputValue }) => (
  <Highlighter
    searchWords={inputValue
      .replace(/[^a-z^0-9]/g, " ")
      .replace(/ {2}/g, " ")
      .split(" ")}
    textToHighlight={label}
    highlightClassName={classes.Highlight}
  />
);

export default formatOptionLabel;
